import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import screens from '../../screens';
import QueueService from '../../services/QueueService';
import { setModal } from '../../state/actions/modal';
import store from '../../state/store';
import parseQueryString from './parseQueryString';
import updateURL from './updateURL';

var EventEmitter = require('events');

var queryParamProxy = /*#__PURE__*/function (_EventEmitter) {
  function queryParamProxy() {
    var _this2;

    _classCallCheck(this, queryParamProxy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, queryParamProxy, [].concat(args));
    _this2.query = undefined;
    _this2.QUERY_PARAM_CHANGE = 'ROUTE_PARAM_CHANGE';
    _this2.ROUTE_CHANGE = 'ROUTE_CHANGE';
    _this2.m_modalPromise = undefined;
    _this2.m_modalPromiseAccept = undefined;
    _this2.paramQueue = new QueueService();
    _this2.lastParams = undefined;

    _this2.init = function () {
      if (_this2.query === undefined) {
        _this2.query = parseQueryString();
      }
    };

    _this2.updateURL = updateURL;
    _this2.enqueueScreens = [screens.DynamicPopups, screens.DailySpin, screens.DailySpinOnboarding, screens.WelcomeBonus, screens.News, screens.LimitedTimeOffer];

    _this2.setQueryParams = function (params) {
      var isParamsValid = _this2.lastParams !== undefined && params.m !== undefined && _this2.lastParams !== params.m && _this2.enqueueScreens.includes(params.m);

      if (isParamsValid) {
        _this2.paramQueue.enqueue(params);

        return;
      }

      _this2.processParams(params);
    };

    _this2.processParams = function (params) {
      if (!params.skip_set_modal) {
        store.dispatch(setModal(params.m));
        _this2.lastParams = params.m;
      }

      _this2.query = _objectSpread(_objectSpread({}, _this2.query), params);
      delete _this2.query.skip_set_modal;

      for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (value === undefined || value === null) {
          delete _this2.query[key];
        }
      }

      _this2.updateURL(_this2.query);

      _this2.emit(_this2.QUERY_PARAM_CHANGE, params);

      if (!_this2.paramQueue.isEmpty()) {
        var queuedParams = _this2.paramQueue.dequeue();

        _this2.processParams(queuedParams);
      }
    };

    _this2.setQueryParamsWithModalPromise = function (params) {
      _this2.m_modalPromise = new Promise(function (resolve) {
        return _this2.m_modalPromiseAccept = resolve;
      });

      _this2.setQueryParams(params);

      return _this2.m_modalPromise;
    };

    _this2.navigate = function (navigation, to, params) {
      if (params instanceof Object) {
        _this2.setQueryParams(params);
      }

      navigation.navigate(to, params);

      _this2.updateURL(_this2.query);

      _this2.emit(_this2.ROUTE_CHANGE);
    };

    _this2.findParam = function (get, missingVal) {
      if (_this2.query === undefined) return missingVal;
      return _this2.query[get] || missingVal;
    };

    _this2.getAllParams = function () {
      if (_this2.query === undefined) return null;
      return _this2.query;
    };

    return _this2;
  }

  _inherits(queryParamProxy, _EventEmitter);

  return _createClass(queryParamProxy, [{
    key: "modalPromiseAccept",
    get: function get() {
      // Enforce single use nature of the accept.
      if (typeof this.m_modalPromiseAccept === 'function') {
        var accept = this.m_modalPromiseAccept;
        this.m_modalPromiseAccept = undefined;
        return accept;
      } // If it's undefined, return a no-op to the caller


      return function () {};
    }
    /**
     * Call this method on page load to read query string into memory and initialize modalPromise
     */

  }, {
    key: "isEmpty",
    value: function isEmpty(obj) {
      for (var key in obj) {
        if (!obj.hasOwnProperty) return false;
        if (obj.hasOwnProperty(key)) return false;
      }

      return true;
    }
    /**
     *
     * @param {Object} params Param object
     */

  }]);
}(EventEmitter);

var QueryParamProxy = new queryParamProxy();
export default QueryParamProxy;